<ng-container [formGroup]="form">
  <input class="form-control" [autocomplete]="element.autocomplete || null" [type]="element.type || 'text'" [formControlName]="element.form" [ngClass]="{'is-invalid': isInvalid}" [placeholder]="element.placeholder || ''" />
  <div class="invalid-feedback" *ngIf="isInvalid">
    <span *ngIf="isRequired">Please provide a valid {{ element.label }}</span>
    <span *ngIf="hasError('Match')">Password not match</span>
    <span *ngIf="hasError('minlength')">The password needs to be at least 8 characters long!</span>
  </div>
</ng-container>
